module.exports = __webpack_public_path__ + "img/mobile-2.0efe9367.png";